var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuBurger = function SvgMenuBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2.308 7.034c-.125.037-.276.19-.298.302a.464.464 0 0 0 .233.516l.098.05h19.32l.097-.05a.43.43 0 0 0 .237-.334c.016-.163-.01-.246-.108-.354-.164-.181.85-.165-9.896-.163-8.265.001-9.594.006-9.683.032m-.03 5.055c-.181.081-.277.223-.277.411 0 .189.096.33.277.411.086.038.425.04 9.723.04s9.636-.002 9.722-.04c.182-.08.277-.222.277-.41q-.002-.287-.277-.412c-.086-.038-.425-.039-9.722-.039-9.298 0-9.637.001-9.723.04m.045 5.024a.52.52 0 0 0-.272.222c-.044.08-.052.12-.045.24.006.122.018.157.075.225.09.109.162.157.266.18.116.026 19.191.026 19.308 0 .103-.023.174-.071.265-.18.057-.069.069-.103.075-.225.01-.18-.05-.306-.196-.401l-.098-.065-9.667-.002c-5.317-.002-9.687.001-9.711.006",
    clipRule: "evenodd"
  })));
};
export default SvgMenuBurger;